import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import axios from "axios";
import { API } from "../../config/api";
import { ApiHelper } from "../../helpers/ApiHelper";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import eye from "../../assets/images/eye.png";
import eyeview from "../../assets/images/view.png";
import caselogo from "../../assets/images/caselogo.png";
import Alertsi9 from "../../assets/images/alert-triangle.svg";

const OldI9form = ({
  review,
  data,
  verifyStatus,
  fetchSections,
  companyName,
  companyAddress,
  unconfirmedData,
  photMatchImage,
  resetForm,
  isNewI9Form,
  redirectToEverify,
  setI9Form,
}) => {
  console.log(review, data);
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [tempId, setTempId] = useState(0);
  const [fields, setFields] = useState([]);
  const [formId, setFormId] = useState(data?.id);
  const [formData, setFormData] = useState([]);
  const [isReview, setIsReview] = useState(review);
  const [error, setError] = useState(false);
  const [error2, setError2] = useState(false);
  const [fileName, setFilename] = useState("");
  const [everifyStatus, setEverifyStatus] = useState(verifyStatus);
  const [unconfirmedFields, setUnconfirmedFields] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([
    "AL",
    "AK",
    "AS",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DE",
    "DC",
    "FM",
    "FL",
    "GA",
    "GU",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MH",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "MP",
    "OH",
    "OK",
    "OR",
    "PW",
    "PA",
    "PR",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VI",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY",
    "CAN",
    "MEX",
  ]);
  const [photoMatchStatus, setPhotoMatchStatus] = useState("");
  const [photoMatchErr, setPhotoMatchErr] = useState(false);
  const [frontImage, setFrontImage] = useState(null);
  const [backImage, setBackImage] = useState(null);
  const [scanandUploadErr, setScanandUploadErr] = useState(false);
  const [reasonModal, setReasonModal] = useState(false);
  const [reasons, setReasons] = useState([]);
  const [reason, setReason] = useState("");
  const [reasonErr, setReasonErr] = useState(false);
  const [reasonDescription, setReasonDescription] = useState("");
  const [checkboxR, setCHeckboxR] = useState(true);
  const [count, setCount] = useState(null);
  const [isFetching, setIsFetching] = useState(false);
  const [closeCaseMOdal, setCloseCaseModal] = useState(false);
  const [closeReason, setCloseReason] = useState("");
  const [closeDescription, setCloseDescription] = useState("");
  const [closeReasons, setCloseReasons] = useState([]);
  const [closeErr, setCloseErr] = useState(false);
  const [furtherActionPDF, setFurtherActionPDF] = useState(null);
  const [furtherAction, setFurtherAction] = useState("");
  const [furtherActionErr, setFurtherActionErr] = useState(false);
  const [refferalDateConfirmationPDF, setRefferalDateConfirmationPDF] =
    useState("");
  const [duplicateContinueReason, setDuplicateContinueReason] = useState("");
  const [duplicateContinueDescription, setDuplicateContinueDescription] =
    useState("");
  const [duplicateContinueReasons, setDuplicateContinueReasons] = useState([]);
  const [duplicateErr, setDuplicateErr] = useState(false);
  const [duplicateModal, setDuplicateModal] = useState(false);
  useEffect(() => {
    // getFields();
    setData();
    getFileName();
    if (location.state?.tempId !== null) {
      setTempId(location?.state?.tempId);
    }
  }, [data]);
  useEffect(() => {
    getCountries();
    getReasons();
  }, []);
  useEffect(() => {
    setCompanyDetails();
    if (unconfirmedData?.length !== 0) {
      let arry = [];
      unconfirmedData?.map((item) => {
        if (item.field_label === "i9_employee_SSNO") {
          let input = generatevalue(item?.field_label);
          if (/^\d{9}$/.test(input)) {
            let formatted = input.replace(/(\d{3})(\d{2})(\d{4})/, "$1-$2-$3");
            arry.push({
              defaultValue: formatted,
              updatedValue: formatted,
              toggle: false,
            });
          } else {
            arry.push({
              defaultValue: generatevalue(item?.field_label),
              updatedValue: generatevalue(item?.field_label),
              toggle: false,
            });
          }
        } else if (
          item?.field_label === "i9_employee_foreign_passport_number"
        ) {
          let input = generatevalue("i9_employee_foreign_passport_number");
          let [first, second] = input?.split(" ");
          arry.push({
            defaultFirstValue: first || "",
            defaultSecondValue: second || "",
            updatedFirstValue: first || "",
            updatedSecondValue: second || "",

            defaultValue: first + " " + second,
            updatedValue: first + " " + second,
            toggle: false,
          });
        } else {
          arry.push({
            defaultValue: generatevalue(item?.field_label),
            updatedValue: generatevalue(item?.field_label),
            toggle: false,
          });
        }
        console.log(arry);
        setUnconfirmedFields(arry);
      });
    }
  }, [formData]);

  const setCompanyDetails = async () => {
    if (
      generatevalue("i9_employer_organization_name") === "" &&
      companyName !== null &&
      companyName !== undefined
    ) {
      let obj = {
        form_id: data?.id,
        field_label: "i9_employer_organization_name",
        interviewee_answer: companyName,
      };
      await ApiHelper.post(API.updateFields, obj)
        .then((resData) => {
          console.log(resData);
          fetchSections();
          setLoader(false);
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    }
    if (
      generatevalue("i9_employer_organization_address") === "" &&
      companyAddress !== null &&
      companyAddress !== undefined
    ) {
      let obj = {
        form_id: data?.id,
        field_label: "i9_employer_organization_address",
        interviewee_answer: companyAddress,
      };
      await ApiHelper.post(API.updateFields, obj)
        .then((resData) => {
          console.log(resData);
          fetchSections();
          setLoader(false);
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    }
  };

  // useEffect(()=>{
  //   if(generatevalue("checkbox")==="1. A citizen of the United States"){
  //     getListValues('US_CITIZEN')
  //   }
  //   if(generatevalue("checkbox")==="2. A noncitizen national of the United States (See Instructions.)"){
  //     getListValues('NONCITIZEN')
  //   }
  //   if(generatevalue("checkbox")==="3. A lawful permanent resident (Enter USCIS or A-Number.)"){
  //     getListValues('LAWFUL_PERMANENT_RESIDENT')
  //   }
  //   if(generatevalue("checkbox")==="4. A noncitizen (other than Item Numbers 2. and 3. above) authorized to work until (exp. date, if any)"){
  //     getListValues('NONCITIZEN_AUTHORIZED_TO_WORK')
  //   }
  // },[])

  // const getListValues=async(data)=>{
  //  await ApiHelper.post(API.getI9DocTypes,{
  //    citizenship_status_code:data,
  //   document_category:"LIST_A"
  //  }).then((res)=>{setListA(data?.document_types)})
  //  await ApiHelper.post(API.getI9DocTypes,{
  //   citizenship_status_code:data,
  //  document_category:"LIST_B"
  // }).then((res)=>{setListA(data?.document_types)})
  // await ApiHelper.post(API.getI9DocTypes,{
  //   citizenship_status_code:data,
  //  document_category:"LIST_C"
  // }).then((res)=>{setListA(data?.document_types)})
  // }

  // set value to formData
  const setData = () => {
    let arr = [];
    data?.fields?.map((item) => {
      let obj = {};
      if (item.field_label === "i9_employee_SSNO") {
        obj = {
          label: item.field_label,
          answer: item.interviewee_answer,
          isShow: false,
        };
      } else {
        obj = {
          label: item.field_label,
          answer: item.interviewee_answer,
        };
      }
      arr.push(obj);
    });
    console.log(arr);
    setFormData(arr);
  };

  // get file name for download
  const getFileName = async () => {
    setLoader(true);
    const obj = {
      intervieweeid: params?.id,
      formid: data?.id,
    };
    await ApiHelper.post(API.downloadForm, obj)
      .then((resData) => {
        console.log(resData);
        if (resData?.data?.success === true) {
          setFilename(resData?.data?.i9Doc);
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  const getFields = async () => {
    setLoader(true);
    const obj = {
      template_type: "i-9form",
    };
    await ApiHelper.post(API.getFields, obj)
      .then((resData) => {
        console.log(resData);
        setFields(resData?.data?.fields);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  //update Field values
  const onTextAreaBlur = async (e) => {
    console.log(e);
    setLoader(true);
    let phone = "";
    if (e.target.name === "i9_employee_telephone_number") {
      if (
        /^\+?(\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?(\d{3}[-.\s]?\d{4})$/.test(
          e.target.value
        )
      ) {
        phone = e.target.value;
      }
      if (
        e.target.value.replace(/[-.\s]/g, "").length === 10 &&
        e.target.value.slice(0, 2) !== "+1" &&
        e.target.value.slice(0, 3) !== "+91" &&
        e.target.value.slice(0, 1) !== "+"
      ) {
        // console.log(e.target.value.slice(0,2),e.target.value.slice(0,3))
        // If the cleaned phone number has 10 digits, add the +1 country code
        phone = "+1" + e.target.value;
      }
      // else{
      //   phone=e.target.value;
      // }
      const obj = {
        form_id: formId,
        field_label: e.target.name,
        interviewee_answer: phone,
      };
      await ApiHelper.post(API.updateFields, obj)
        .then((resData) => {
          console.log(resData);
          fetchSections(params.id);
          setLoader(false);
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    } else {
      const obj = {
        form_id: formId,
        field_label: e.target.name,
        interviewee_answer: e.target.value,
      };
      await ApiHelper.post(API.updateFields, obj)
        .then((resData) => {
          console.log(resData);
          setLoader(false);
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    }
  };

  // display value
  const generatevalue = (fieldName) => {
    let obj = formData.filter((item) => item?.label === fieldName);
    // console.log(obj)
    if (obj[0]?.answer === null) {
      return "";
    } else return obj[0]?.answer;
  };

  // onchange
  const onTextareaChange = (e) => {
    const updatedItems = formData.map((item) => {
      if (item.label === e.target.name) {
        return { ...item, answer: e.target.value };
      }
      return item;
    });
    setFormData(updatedItems);
  };

  useEffect(() => {
    for (let i = 0; i < formData.length; i++) {
      if (formData[i]?.label === "checkbox") {
        if (formData[i]?.answer === "A noncitizen") {
          if (
            generatevalue("i9_employee_USCIS_number") === "" &&
            generatevalue("i9_employee_formi94_admission_number") === "" &&
            generatevalue("i9_employee_foreign_passport_number") === ""
          ) {
            setError2(true);
          }
          if (
            generatevalue("i9_employee_USCIS_number") !== "" ||
            generatevalue("i9_employee_formi94_admission_number") !== "" ||
            generatevalue("i9_employee_foreign_passport_number") !== ""
          ) {
            setError2(false);
          }
        }
      }
    }
  }, [formData]);

  //submit form
  const submitForm = async (e) => {
    e.preventDefault();
    setLoader(true);
    let err = false;
    setError2(false);
    for (let i = 0; i < formData.length; i++) {
      if (
        formData[i]?.label === "i9_employee_lastname" ||
        formData[i]?.label === "i9_employee_firstname" ||
        formData[i]?.label === "i9_employee_address" ||
        formData[i]?.label === "i9_employee_city_town" ||
        formData[i]?.label === "i9_employee_state" ||
        formData[i]?.label === "checkbox" ||
        formData[i]?.label === "i9_employee_sign"
      ) {
        if (formData[i]?.answer === "" || formData[i]?.answer === null) {
          err = true;
        }
        if (formData[i]?.label === "checkbox") {
          if (formData[i]?.answer === "A lawful permanent resident") {
            if (generatevalue("checkbox3_i9_employee_USCISNumber") === "") {
              err = true;
            }
          }
          if (formData[i]?.answer === "A noncitizen") {
            if (
              generatevalue("i9_employee_USCIS_number") === "" &&
              generatevalue("i9_employee_formi94_admission_number") === "" &&
              generatevalue("i9_employee_foreign_passport_number") === ""
            ) {
              err = true;
              setError2(true);
            }
          }
        }
      }
      if (formData[i]?.label === "i9_employee_SSNO") {
        let ssnRegex = /^\d{3}-?\d{2}-?\d{4}$/.test(formData[i]?.answer);
        if (
          formData[i]?.answer === "" ||
          formData[i]?.answer === null ||
          ssnRegex === false
        ) {
          err = true;
        }
      }
      if (formData[i]?.label === "i9_employee_zip") {
        let ssnRegex = /^\d{5}(?:[-\s]\d{4})?$/.test(formData[i]?.answer);
        if (
          formData[i]?.answer === "" ||
          formData[i]?.answer === null ||
          ssnRegex === false
        ) {
          err = true;
        }
      }
      if (formData[i]?.label === "i9_employee_dob") {
        let ssnRegex =
          /(0[1-9]|1[0,1,2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(19|20)\d{2}/.test(
            formData[i]?.answer
          );
        if (
          formData[i]?.answer === "" ||
          formData[i]?.answer === null ||
          ssnRegex === false
        ) {
          err = true;
        }
      }
      if (formData[i]?.label === "i9_employee_email") {
        let ssnRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(
          formData[i]?.answer
        );
        if (
          formData[i]?.answer === "" ||
          formData[i]?.answer === null ||
          ssnRegex === false
        ) {
          err = true;
        }
      }
      if (formData[i]?.label === "i9_employee_telephone_number") {
        let ssnRegex =
          /^(\+\d{1,3}[-.\s]?)?(\d{3}[-.\s]?\d{3}[-.\s]?\d{4})$/.test(
            formData[i]?.answer
          );
        if (
          formData[i]?.answer === "" ||
          formData[i]?.answer === null ||
          ssnRegex === false
        ) {
          err = true;
        }
      }
      if (isReview) {
        if (
          formData[i]?.label === "i9_employer_firstday" ||
          formData[i]?.label === "i9_last_name_title_employer" ||
          formData[i]?.label === "i9_employer_sign" ||
          formData[i]?.label === "i9_employer_organization_name" ||
          formData[i]?.label === "i9_employer_organization_address"
        ) {
          if (formData[i]?.answer === "" || formData[i]?.answer === null) {
            err = true;
          }
        }
        if (
          generatevalue("listA_document_title1") === "" &&
          generatevalue("listB_document1") === "" &&
          generatevalue("listC_document1") === ""
        ) {
          err = true;
        }
        if (
          generatevalue("listA_document_title1") !== "" &&
          generatevalue("listA_issuing_authority1") === ""
        ) {
          err = true;
        }
        if (
          generatevalue("listB_document1") !== "" &&
          generatevalue("listB_document2") === ""
        ) {
          err = true;
        }
        if (
          generatevalue("listC_document1") !== "" &&
          generatevalue("listC_document2") === ""
        ) {
          err = true;
        }
      }
    }
    console.log(err);
    setError(err);
    const ChatbotId = localStorage.getItem("candidateChatbotId");
    let user = JSON.parse(localStorage.getItem("UserData"));
    if (err === true) {
      toast("Form Not Completed!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setLoader(false);
    } else {
      if (!isReview) {
        const formobj = {
          form_id: formId,
          field_label: "i9_employee_today_date",
          interviewee_answer: moment().format("MMMM DD, YYYY"),
        };
        await ApiHelper.post(API.updateFields, formobj)
          .then((resData) => {
            console.log(resData);
          })
          .catch((err) => {
            setLoader(false);
            console.log(err);
          });
      }
      if (isReview) {
        const formobj = {
          form_id: formId,
          field_label: "i9_employer_todays_date",
          interviewee_answer: moment().format("MMMM DD, YYYY"),
        };
        await ApiHelper.post(API.updateFields, formobj)
          .then((resData) => {
            console.log(resData);
          })
          .catch((err) => {
            setLoader(false);
            console.log(err);
          });
      }

      let obj = {
        formid: data.id,
        interviewid: params.id,
        template_id: params.tempid !== undefined ? params.tempid : 0,
      };
      let formData = {
        chatbotid: ChatbotId,
        intervieweeid: params?.id,
        formid: data?.id,
        userId: user?.id,
        template_id:
          tempId !== 0
            ? tempId
            : location.state?.tempId !== null
            ? location.state?.tempId
            : 0,
      };
      await ApiHelper.post(
        isReview ? API.employerConfirm : API.confirmForm,
        isReview ? formData : obj
      )
        .then((resData) => {
          console.log(resData);
          if (resData.data.success === true) {
            fetchSections(params.id);
            getFileName();
            let filepath = API.legalFormsView + resData?.data?.pdfurl;
            if (!isReview && resData?.data?.pdfurl !== "") {
              const link = document.createElement("a");
              link.href = filepath;
              link.download = "avenu";
              link.target = "_blank";
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
            toast("Form Completed!", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });

            // if(item.section_forms?.length === i + 1)
            //  {
            //     setNextInd(index+1)
            //  }
            setLoader(false);
          } else {
            toast(resData?.data?.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
            setLoader(false);
          }
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    }
  };

  function isValidDateTimeString(str) {
    const parsed = Date.parse(str);
    return !isNaN(parsed);
  }

  const formatDateToYYYYMMDD = (dateString) => {
    console.log(dateString);
    const regex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/;
    if (regex.test(dateString)) {
      const date = new Date(dateString);
      console.log(date);
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-based
      const day = date.getDate().toString().padStart(2, "0");

      return `${year}-${month}-${day}`;
    }
  };

  const isValidDateString = (dateString) => {
    // Try to create a new Date object
    const date = new Date(dateString);

    // Check if the created date is valid
    // Date.parse() returns NaN if the date is invalid
    return !isNaN(date.getTime());
  };
  // get countries
  const getCountries = async () => {
    setLoader(true);
    await ApiHelper.post(API.getI9countries)
      .then((resData) => {
        console.log(resData);
        setCountries(resData?.data?.countries);
      })
      .catch((err) => {
        //setLoader(false);
        console.log(err);
      });
  };

  // get reasons for delay
  const getReasons = async () => {
    setLoader(true);
    await ApiHelper.post(API.getReasons)
      .then((resData) => {
        console.log(resData);
        setReasons(resData?.data?.reasons_for_delay);
        //setLoader(false);
      })
      .catch((err) => {
        //setLoader(false);
        console.log(err);
      });
  };

  //get duplicate Continue Reasons
  const getduplicateReasons = async () => {
    setLoader(true);
    await ApiHelper.post(API.duplicateReasons)
      .then((resData) => {
        console.log(resData);
        setDuplicateContinueReasons(resData?.data?.duplicate_continue_reasons);
        if (!isReview) setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };

  // get close case reasons
  const getCloseCaseReasons = async () => {
    setLoader(true);
    let obj = {
      caseId: data?.e_verify_casId,
    };
    await ApiHelper.post(API.getCloseCaseReasons, obj)
      .then((resData) => {
        console.log(resData);
        setCloseReasons(resData?.data?.case_closure_reasons);
        // if (generatevalue("checkbox") === "") {
        setLoader(false);
        // }
      })
      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  };
  //photo match
  const photoMatch = async (e) => {
    e.preventDefault();
    setLoader(true);
    if (photoMatchStatus == "") {
      setPhotoMatchErr(true);
      setLoader(false);
    } else {
      setPhotoMatchErr(false);
      let obj = {
        formid: data?.id,
        caseId: data?.e_verify_casId,
        status: photoMatchStatus,
      };
      await ApiHelper.post(API.photoMatch, obj)
        .then((resData) => {
          console.log(resData);
          if (resData?.status === 200) {
            isNewI9Form ? redirectToEverify(data?.id) : fetchSections();
            setLoader(false);
          }
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    }
  };

  //scan and upload
  const scanandUpload = async (e) => {
    e.preventDefault();
    console.log(frontImage);
    console.log(backImage);
    if (frontImage === "" || backImage === "") {
      setScanandUploadErr(true);
    } else {
      setLoader(true);
      setScanandUploadErr(false);
      var bodyFormData = new FormData();
      bodyFormData.append("frontimage", frontImage);
      bodyFormData.append("backimage", backImage);
      bodyFormData.append("caseId", data?.e_verify_casId);
      bodyFormData.append("formid", data?.id);
      await ApiHelper.mediapost(API.scanandUpload, bodyFormData)
        .then((resData) => {
          console.log(resData);
          if (resData?.status === 200) {
            isNewI9Form ? redirectToEverify(data?.id) : fetchSections();
            setLoader(false);
          }
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    }
  };
  const downloadfurtherAction = async (e) => {
    e.preventDefault();
    if (furtherActionPDF === null) {
      setLoader(true);
      let obj = {
        formid: data?.id,
        caseId: data?.e_verify_casId,
        interviewid: params?.id,
      };
      await ApiHelper.post(API.downloadfurtherAction, obj)
        .then((resData) => {
          console.log(resData);
          if (resData?.status === 200) {
            const link = document.createElement("a");
            link.href =
              API.mediaView +
              "E-verifyDocs/further_action/" +
              params?.id +
              "/" +
              resData?.data.pdf;
            link.download = resData?.data.pdf;
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            isNewI9Form ? redirectToEverify(data?.id) : fetchSections();
            setLoader(false);
          }
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    } else {
      const link = document.createElement("a");
      link.href =
        API.mediaView +
        "E-verifyDocs/further_action/" +
        params?.id +
        "/" +
        furtherActionPDF;
      link.download = furtherActionPDF;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const saveFurtherAction = async (e) => {
    e.preventDefault();
    setLoader(true);
    if (furtherAction === "Step1") {
      setFurtherActionErr(false);
      if (furtherActionPDF === null) {
        toast(
          "You must download, print, and review the Further Action Notice in order to continue.",
          {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          }
        );
        setLoader(false);
      } else {
        let obj = {
          formid: data?.id,
          caseId: data?.e_verify_casId,
        };
        await ApiHelper.post(API.referCase, obj)
          .then((resData) => {
            console.log(resData);
            if (resData?.status === 200) {
              isNewI9Form ? redirectToEverify(data?.id) : fetchSections();
              setLoader(false);
            }
          })
          .catch((err) => {
            setLoader(false);
            console.log(err);
          });
      }
    } else if (furtherAction === "Step2") {
      setFurtherActionErr(false);
      let obj = {
        formid: data?.id,
        caseId: data?.e_verify_casId,
      };
      await ApiHelper.post(API.noAction, obj)
        .then((resData) => {
          console.log(resData);
          if (resData?.status === 200) {
            isNewI9Form ? redirectToEverify(data?.id) : fetchSections();
            setLoader(false);
          }
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    } else if (furtherAction === "") {
      setFurtherActionErr(true);
      setLoader(false);
    } else {
      setFurtherActionErr(false);
      setLoader(false);
    }
  };

  const downloadReferalDateConfirmation = async (e) => {
    e.preventDefault();
    if (refferalDateConfirmationPDF === null) {
      setLoader(true);
      let obj = {
        formid: data?.id,
        caseId: data?.e_verify_casId,
        interviewid: params?.id,
      };
      await ApiHelper.post(API.downloadReferalDateConfirmation, obj)
        .then((resData) => {
          console.log(resData);
          if (resData?.status === 200) {
            const link = document.createElement("a");
            link.href =
              API.mediaView +
              "E-verifyDocs/referal_date_confirmation/" +
              params?.id +
              "/" +
              resData?.data.pdf;
            link.download = resData?.data.pdf;
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            isNewI9Form ? redirectToEverify(data?.id) : fetchSections();
            setLoader(false);
          }
        })
        .catch((err) => {
          setLoader(false);
          console.log(err);
        });
    } else {
      const link = document.createElement("a");
      link.href =
        API.mediaView +
        "E-verifyDocs/referal_date_confirmation/" +
        params?.id +
        "/" +
        refferalDateConfirmationPDF;
      link.download = refferalDateConfirmationPDF;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const closeCase = async (e, reason) => {
    e.preventDefault();
    setLoader(true);
    if (closeReason !== "" || reason !== "") {
      if (
        closeReason === "EMPLOYEE_CONTINUES_TO_WORK_AFTER_FNC" ||
        closeReason === "OTHER_FREE_TEXT" ||
        closeReason === "OTHER"
      ) {
        if (closeDescription !== "") {
          let obj = {
            formid: data?.id,
            caseId: data?.e_verify_casId,
            case_closure_reason_code: reason === "" ? closeReason : reason,
            description: closeDescription,
          };
          await ApiHelper.post(API.closeCase, obj)
            .then((resData) => {
              console.log(resData);
              if (resData?.status === 200) {
                setCloseReason("");
                setCloseCaseModal(false);
                isNewI9Form ? redirectToEverify(data?.id) : fetchSections();
                setLoader(false);
              }
            })
            .catch((err) => {
              setLoader(false);
              console.log(err);
            });
        } else {
          setCloseErr(true);
          setLoader(false);
        }
      } else {
        let obj = {
          formid: data?.id,
          caseId: data?.e_verify_casId,
          case_closure_reason_code: reason === "" ? closeReason : reason,
          description: "",
        };
        await ApiHelper.post(API.closeCase, obj)
          .then((resData) => {
            console.log(resData);
            if (resData?.status === 200) {
              setCloseCaseModal(false);
              isNewI9Form ? redirectToEverify(data?.id) : fetchSections();
              setLoader(false);
            }
          })
          .catch((err) => {
            setLoader(false);
            console.log(err);
          });
      }
    } else {
      setCloseErr(true);
      setLoader(false);
    }
  };

  const reverify = async () => {
    setLoader(true);
    let fields = unconfirmedData?.map((item, index) => ({
      field_name: item?.everify_label,
      value: isValidDateString(unconfirmedFields[index]?.updatedValue)
        ? formatDateToYYYYMMDD(unconfirmedFields[index]?.updatedValue)
        : unconfirmedFields[index]?.updatedValue,
    }));
    let dbparams = unconfirmedData?.map((item, index) => ({
      field_name: item?.field_label,
      value: isValidDateString(unconfirmedFields[index]?.updatedValue)
        ? formatDateToYYYYMMDD(unconfirmedFields[index]?.updatedValue)
        : unconfirmedFields[index]?.updatedValue,
    }));
    const obj = {
      caseId: data?.e_verify_casId,
      formid: data?.id,
      fields: fields,
      dbparams: dbparams,
    };
    console.log(obj);
    await ApiHelper.post(API.reverifyI9form, obj).then((resData) => {
      console.log(resData);
      if (resData?.data?.status === true) {
        redirectToEverify(data?.id);
        fetchSections();
        toast(resData?.data?.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setLoader(false);
      } else {
        toast(resData?.data?.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setLoader(false);
      }
    });
  };
  return (
    <div>
      <div className="mx-auto" style={{ width: "95%" }}>
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="me-3 mb-4 rev-padd-tap">
              <div>
                <p className="head-l">
                  <span>
                    <strong>Employment Eligibility Verification</strong>
                  </span>
                </p>
                <p className="head-l">
                  <strong> Department of Homeland Security</strong>
                </p>
                <p className="head-l">
                  U.S. Citizenship and Immigration Services
                </p>
              </div>
            </div>

            <p className="para-fonts">
              <strong>
                START HERE: Employers must ensure the form instructions are
                available to employees when completing this form. Employers are
                liable for failing to comply with the requirements for
                completing this form. See below and the{" "}
                <a
                  href="https://www.uscis.gov/i-9"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Instructions
                </a>
              </strong>
              .
            </p>
            <p className="para-fonts">
              <strong>ANTI-DISCRIMINATION NOTICE: </strong>
              All employees can choose which acceptable documentation to present
              for Form I-9. Employers cannot ask employees for documentation to
              verify information in
              <strong> Section 1</strong>, or specify which acceptable
              documentation employees must present for{" "}
              <strong>Section 2</strong> or Supplement B, Reverification and
              Rehire. Treating employees differently based on their citizenship,
              immigration status, or national origin may be illegal.
            </p>
            <p className="para-fonts">
              <strong>Section 1. Employee Information and Attestation:</strong>
              Employees must complete and sign Section 1 of Form I-9 no later
              than <strong> first day of employment </strong>
              but not before accepting a job offer.
            </p>

            <form>
              <div class="row g-3">
                <div class="col-md-6">
                  <label for="your-name" class="form-label">
                    Last Name (Family Name){" "}
                  </label>
                  <textarea
                    class="form-control text-class"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("i9_employee_lastname") === "" ||
                          generatevalue("i9_employee_lastname") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    id="your-message"
                    name="i9_employee_lastname"
                    rows="5"
                    value={generatevalue("i9_employee_lastname")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextareaChange(e);
                    }}
                  ></textarea>
                </div>

                <div class="col-md-6">
                  <label for="your-surname" class="form-label">
                    First Name (Given Name){" "}
                  </label>
                  <textarea
                    class="form-control text-class"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("i9_employee_firstname") === "" ||
                          generatevalue("i9_employee_firstname") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    id="your-message"
                    name="i9_employee_firstname"
                    rows="5"
                    value={generatevalue("i9_employee_firstname")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextareaChange(e);
                    }}
                  ></textarea>
                </div>

                <div class="col-md-6">
                  <label for="your-email" class="form-label">
                    Middle Initial (if any)
                  </label>
                  <textarea
                    class="form-control text-class"
                    id="your-message"
                    name="i9_employee_middle_name"
                    rows="5"
                    value={generatevalue("i9_employee_middle_name")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextareaChange(e);
                    }}
                  ></textarea>
                </div>

                <div class="col-md-6">
                  <label for="your-subject" class="form-label">
                    Other Last Names Used (if any)
                  </label>
                  <textarea
                    class="form-control text-class"
                    id="your-message"
                    name="i9_employee_other_names"
                    rows="5"
                    value={generatevalue("i9_employee_other_names")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextareaChange(e);
                    }}
                  ></textarea>
                </div>

                <div class="col-md-6">
                  <label for="your-subject" class="form-label">
                    Address (Street Number and Name)
                  </label>
                  <textarea
                    class="form-control text-class"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("i9_employee_address") === "" ||
                          generatevalue("i9_employee_address") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    id="your-message"
                    name="i9_employee_address"
                    rows="5"
                    value={generatevalue("i9_employee_address")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextareaChange(e);
                    }}
                  ></textarea>
                </div>

                <div class="col-md-6">
                  <label for="your-subject" class="form-label">
                    Apt. Number (if any)
                  </label>
                  <textarea
                    class="form-control text-class"
                    id="your-message"
                    name="i9_employee_apt_number"
                    rows="5"
                    value={generatevalue("i9_employee_apt_number")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextareaChange(e);
                    }}
                  ></textarea>
                </div>

                <div class="col-md-6">
                  <label for="your-subject" class="form-label">
                    City or Town
                  </label>
                  <textarea
                    class="form-control text-class"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("i9_employee_city_town") === "" ||
                          generatevalue("i9_employee_city_town") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    id="your-message"
                    name="i9_employee_city_town"
                    rows="5"
                    value={generatevalue("i9_employee_city_town")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextareaChange(e);
                    }}
                  ></textarea>
                </div>

                <div class="col-md-6">
                  <label for="your-subject" class="form-label">
                    State (abbreviate State)
                  </label>
                  {/* <textarea class="form-control text-class" style={{ border: error===true && (generatevalue("i9_employee_state") === "" || generatevalue("i9_employee_state") === null) ? '1px solid red' : null}} id="your-message" name="i9_employee_state" rows="5" value={generatevalue("i9_employee_state")} onBlur={(e)=>{(!isReview && data?.completed_status===0) && onTextAreaBlur(e)}} onChange={(e)=>{(!isReview && data?.completed_status===0) && onTextareaChange(e) }}></textarea> */}
                  <select
                    class="form-select select-height"
                    aria-label="Default select example"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("i9_employee_state") === "" ||
                          generatevalue("i9_employee_state") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    id="your-message"
                    name="i9_employee_state"
                    rows="5"
                    value={generatevalue("i9_employee_state")}
                    onChange={(e) => {
                      if (!isReview && data?.completed_status === 0) {
                        onTextareaChange(e);
                        onTextAreaBlur(e);
                      }
                    }}
                  >
                    <option selected>select</option>
                    {states.map((item) => {
                      return <option value={item}>{item}</option>;
                    })}
                  </select>
                </div>

                <div class="col-md-6">
                  <label for="your-subject" class="form-label">
                    ZIP Code
                  </label>
                  <textarea
                    class="form-control text-class"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("i9_employee_zip") === "" ||
                          generatevalue("i9_employee_zip") === null ||
                          /^\d{5}(?:[-\s]\d{4})?$/.test(
                            generatevalue("i9_employee_zip")
                          ) === false)
                          ? "1px solid red"
                          : null,
                    }}
                    id="your-message"
                    name="i9_employee_zip"
                    rows="5"
                    value={generatevalue("i9_employee_zip")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextareaChange(e);
                    }}
                  ></textarea>
                </div>

                <div class="col-md-6">
                  <label for="your-subject" class="form-label">
                    Date of Birth (mm/dd/yyyy)
                  </label>
                  <textarea
                    class="form-control text-class"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("i9_employee_dob") === "" ||
                          generatevalue("i9_employee_dob") === null ||
                          /(0[1-9]|1[0,1,2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(19|20)\d{2}/.test(
                            generatevalue("i9_employee_dob")
                          ) === false)
                          ? "1px solid red"
                          : null,
                    }}
                    id="your-message"
                    name="i9_employee_dob"
                    rows="5"
                    value={generatevalue("i9_employee_dob")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextareaChange(e);
                    }}
                  ></textarea>
                </div>

                <div class="col-md-6">
                  <div>
                    <p className="para-fonts">
                      <span className="mul-txt">
                        U.S. Social Security Number
                      </span>
                      &nbsp;
                    </p>
                  </div>

                  {/* <textarea class="form-control text-class" style={{ border: error===true && (generatevalue("i9_employee_SSNO") === "" || generatevalue("i9_employee_SSNO") === null || /^\d{3}-?\d{2}-?\d{4}$/.test(generatevalue("i9_employee_SSNO"))===false) ? '1px solid red' : null}} id="your-message" name="i9_employee_SSNO" rows="5" value={generatevalue("i9_employee_SSNO")} onBlur={(e)=>{(!isReview && data?.completed_status===0) && onTextAreaBlur(e)}} onChange={(e)=>{(!isReview && data?.completed_status===0) && onTextareaChange(e) }}></textarea> */}
                  <div class="input-group-append pass-div-width">
                    <input
                      type={formData[13]?.isShow === true ? "text" : "password"}
                      class="form-control pass-inpt"
                      style={{
                        border:
                          error === true &&
                          (generatevalue("i9_employee_SSNO") === "" ||
                            generatevalue("i9_employee_SSNO") === null ||
                            /^\d{3}-?\d{2}-?\d{4}$/.test(
                              generatevalue("i9_employee_SSNO")
                            ) === false)
                            ? "1px solid red"
                            : null,
                        borderRight: "none",
                      }}
                      id="your-message"
                      name="i9_employee_SSNO"
                      rows="5"
                      value={generatevalue("i9_employee_SSNO")}
                      onBlur={(e) => {
                        !isReview &&
                          data?.completed_status === 0 &&
                          onTextAreaBlur(e);
                      }}
                      onChange={(e) => {
                        !isReview &&
                          data?.completed_status === 0 &&
                          onTextareaChange(e);
                      }}
                    />
                    <button
                      type="button"
                      class="btn eye-bttn"
                      data-toggle="password"
                      style={{
                        border:
                          error === true &&
                          (generatevalue("i9_employee_SSNO") === "" ||
                            generatevalue("i9_employee_SSNO") === null ||
                            /^\d{3}-?\d{2}-?\d{4}$/.test(
                              generatevalue("i9_employee_SSNO")
                            ) === false)
                            ? "1px solid red"
                            : null,
                        borderLeft: "none",
                      }}
                      onClick={() => {
                        let data = [...formData];
                        if (data) {
                          data[13].isShow = !data[13].isShow;
                        }
                        console.log(data);
                        setFormData(data);
                      }}
                    >
                      <img
                        src={formData[13]?.isShow ? eyeview : eye}
                        alt="test"
                        className="menu_icon eye-img"
                      />
                    </button>
                  </div>
                </div>

                <div class="col-md-6">
                  <p className="para-fonts">
                    <span className="mul-txt">Employee's Email Address </span>
                    &nbsp;
                  </p>
                  <textarea
                    class="form-control text-class"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("i9_employee_email") === "" ||
                          generatevalue("i9_employee_email") === null ||
                          /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g.test(
                            generatevalue("i9_employee_email")
                          ) === false)
                          ? "1px solid red"
                          : null,
                    }}
                    id="your-message"
                    name="i9_employee_email"
                    rows="5"
                    value={generatevalue("i9_employee_email")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextareaChange(e);
                    }}
                  ></textarea>
                </div>

                <div class="col-md-6">
                  <label for="your-subject" class="form-label">
                    Employee's Telephone Number
                  </label>
                  <textarea
                    class="form-control text-class"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("i9_employee_telephone_number") === "" ||
                          generatevalue("i9_employee_telephone_number") ===
                            null ||
                          /^(\+\d{1,3}[-.\s]?)?(\d{3}[-.\s]?\d{3}[-.\s]?\d{4})$/.test(
                            generatevalue("i9_employee_telephone_number")
                          ) === false)
                          ? "1px solid red"
                          : null,
                    }}
                    id="your-message"
                    name="i9_employee_telephone_number"
                    rows="5"
                    value={generatevalue("i9_employee_telephone_number")}
                    onBlur={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextAreaBlur(e);
                    }}
                    onChange={(e) => {
                      !isReview &&
                        data?.completed_status === 0 &&
                        onTextareaChange(e);
                    }}
                  ></textarea>
                </div>

                {/* <h6 className='mb-0' > <strong>I am aware that federal law provides for imprisonment and/or fines for false statements, or the use of false documents, in connection with the completion of this form. I attest, under penalty of perjury, that this information, including my selection of the box attesting to my citizenship or immigration status, is true and correct.</strong></h6>
        <p className='para-fonts'>Check one of the following boxes to attest to your citizenship or immigration status (See page 2 and 3 of the instructions.):</p> */}

                <div class="col-12">
                  <input
                    type="radio"
                    class="form-check-input radio-sizee"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("checkbox") === "" ||
                          generatevalue("checkbox") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    name="checkbox"
                    value="1. A citizen of the United States"
                    onChange={(e) => {
                      if (!isReview && data?.completed_status === 0) {
                        onTextareaChange(e);
                        onTextAreaBlur(e);
                      }
                    }}
                    checked={
                      generatevalue("checkbox") ===
                      "1. A citizen of the United States"
                    }
                  />
                  <label for="vehicle1" className=" w4form-l">
                    1. A citizen of the United States
                  </label>
                </div>

                <div class="col-12">
                  <input
                    type="radio"
                    class="form-check-input radio-sizee"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("checkbox") === "" ||
                          generatevalue("checkbox") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    name="checkbox"
                    value="2. A noncitizen national of the United States (See Instructions.)"
                    onChange={(e) => {
                      if (!isReview && data?.completed_status === 0) {
                        onTextareaChange(e);
                        onTextAreaBlur(e);
                      }
                    }}
                    checked={
                      generatevalue("checkbox") ===
                      "2. A noncitizen national of the United States (See Instructions.)"
                    }
                  />
                  <label for="vehicle2" className=" w4form-l">
                    {" "}
                    2. A noncitizen national of the United States (See
                    Instructions.)
                  </label>
                </div>

                <div class="col-12">
                  <input
                    type="radio"
                    class="form-check-input radio-sizee"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("checkbox") === "" ||
                          generatevalue("checkbox") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    name="checkbox"
                    value="3. A lawful permanent resident (Enter USCIS or A-Number.)"
                    onChange={(e) => {
                      if (!isReview && data?.completed_status === 0) {
                        onTextareaChange(e);
                        onTextAreaBlur(e);
                      }
                    }}
                    checked={
                      generatevalue("checkbox") ===
                      "3. A lawful permanent resident (Enter USCIS or A-Number.)"
                    }
                  />
                  <label for="vehicle3" className=" w4form-l">
                    {" "}
                    3. A lawful permanent resident (Enter USCIS or A-Number.)
                  </label>
                </div>

                <div class="col-12">
                  <input
                    type="radio"
                    class="form-check-input radio-sizee"
                    style={{
                      border:
                        error === true &&
                        (generatevalue("checkbox") === "" ||
                          generatevalue("checkbox") === null)
                          ? "1px solid red"
                          : null,
                    }}
                    name="checkbox"
                    value="4. A noncitizen (other than Item Numbers 2. and 3. above) authorized to work until (exp. date, if any)"
                    onChange={(e) => {
                      if (!isReview && data?.completed_status === 0) {
                        onTextareaChange(e);
                        onTextAreaBlur(e);
                      }
                    }}
                    checked={
                      generatevalue("checkbox") ===
                      "4. A noncitizen (other than Item Numbers 2. and 3. above) authorized to work until (exp. date, if any)"
                    }
                  />
                  <label for="vehicle3" className=" w4form-l">
                    {" "}
                    4. A noncitizen (other than Item Numbers 2. and 3. above)
                    authorized to work until (exp. date, if any)
                  </label>
                </div>

                {(generatevalue("checkbox") ===
                  "4. A noncitizen (other than Item Numbers 2. and 3. above) authorized to work until (exp. date, if any)" ||
                  generatevalue("checkbox") === "" ||
                  generatevalue("checkbox") === undefined) && (
                  <div class="col-md-12">
                    <label for="your-subject" class="form-label">
                      A noncitizen (other than Item Numbers 2. and 3. above)
                      authorized to work until (exp. date, if any){" "}
                    </label>
                    <textarea
                      class="form-control text-class"
                      id="your-message"
                      name="checkboxi9_employee_expdate"
                      rows="5"
                      value={generatevalue("checkboxi9_employee_expdate")}
                      onBlur={(e) => {
                        !isReview &&
                          data?.completed_status === 0 &&
                          onTextAreaBlur(e);
                      }}
                      onChange={(e) => {
                        !isReview &&
                          data?.completed_status === 0 &&
                          onTextareaChange(e);
                      }}
                    ></textarea>
                  </div>
                )}

                {(generatevalue("checkbox") ===
                  "3. A lawful permanent resident (Enter USCIS or A-Number.)" ||
                  generatevalue("checkbox") === "" ||
                  generatevalue("checkbox") === undefined) && (
                  <div class="col-md-12">
                    <p className="para-fonts">
                      If checked number 3, please enter USCIS or A-Number{" "}
                    </p>
                    <textarea
                      class="form-control text-class"
                      style={{
                        border:
                          error === true &&
                          generatevalue("checkbox") ===
                            "A lawful permanent resident" &&
                          (generatevalue(
                            "checkbox3_i9_employee_USCISNumber"
                          ) === "" ||
                            generatevalue(
                              "checkbox3_i9_employee_USCISNumber"
                            ) === null)
                            ? "1px solid red"
                            : null,
                      }}
                      id="your-message"
                      name="checkbox3_i9_employee_USCISNumber"
                      rows="5"
                      value={generatevalue("checkbox3_i9_employee_USCISNumber")}
                      onBlur={(e) => {
                        !isReview &&
                          data?.completed_status === 0 &&
                          onTextAreaBlur(e);
                      }}
                      onChange={(e) => {
                        !isReview &&
                          data?.completed_status === 0 &&
                          onTextareaChange(e);
                      }}
                    ></textarea>
                  </div>
                )}

                {(generatevalue("checkbox") ===
                  "4. A noncitizen (other than Item Numbers 2. and 3. above) authorized to work until (exp. date, if any)" ||
                  generatevalue("checkbox") === "" ||
                  generatevalue("checkbox") === undefined) && (
                  <>
                    <div class="col-md-12">
                      <label for="your-subject" class="form-label">
                        {" "}
                        If you check Item Number 4., enter one of these:
                      </label>
                      <p className="para-fonts">USCIS A-Number </p>
                      <textarea
                        class="form-control text-class"
                        style={{
                          border: error2 === true ? "1px solid red" : null,
                        }}
                        id="your-message"
                        name="i9_employee_USCIS_number"
                        rows="5"
                        value={generatevalue("i9_employee_USCIS_number")}
                        onBlur={(e) => {
                          !isReview &&
                            data?.completed_status === 0 &&
                            onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          !isReview &&
                            data?.completed_status === 0 &&
                            onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    <div class="col-md-6">
                      <p className="para-fonts">Form I-94 Admission Number </p>
                      <textarea
                        class="form-control text-class"
                        style={{
                          border: error2 === true ? "1px solid red" : null,
                        }}
                        id="your-message"
                        name="i9_employee_formi94_admission_number"
                        rows="5"
                        value={generatevalue(
                          "i9_employee_formi94_admission_number"
                        )}
                        onBlur={(e) => {
                          !isReview &&
                            data?.completed_status === 0 &&
                            onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          !isReview &&
                            data?.completed_status === 0 &&
                            onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    <div class="col-md-6">
                      <p className="para-fonts">
                        Foreign Passport Number and Country of Issuance
                      </p>
                      <textarea
                        class="form-control text-class"
                        style={{
                          border: error2 === true ? "1px solid red" : null,
                        }}
                        id="your-message"
                        name="i9_employee_foreign_passport_number"
                        rows="5"
                        value={generatevalue(
                          "i9_employee_foreign_passport_number"
                        )}
                        onBlur={(e) => {
                          !isReview &&
                            data?.completed_status === 0 &&
                            onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          !isReview &&
                            data?.completed_status === 0 &&
                            onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>
                  </>
                )}

                <div class="col-12">
                  <label class="form-check-label" for="flexCheckDefault">
                    I am aware that federal law provides for imprisonment and/or
                    fines for false statements, or the use of false documents,
                    in connection with the completion of this form. I attest,
                    under penalty of perjury, that this information, including
                    my selection of the box attesting to my citizenship or
                    immigration status, is true and correct.
                  </label>
                </div>

                <div class="col-6">
                  <div class="form-floating wraper minH mb-3">
                    <input
                      type="text"
                      class="form-control signs"
                      style={{
                        border:
                          error === true &&
                          (generatevalue("i9_employee_sign") === "" ||
                            generatevalue("i9_employee_sign") === null)
                            ? "1px solid red"
                            : null,
                      }}
                      id="your-message"
                      name="i9_employee_sign"
                      rows="5"
                      value={generatevalue("i9_employee_sign")}
                      onBlur={(e) => {
                        !isReview &&
                          data?.completed_status === 0 &&
                          onTextAreaBlur(e);
                      }}
                      onChange={(e) => {
                        !isReview &&
                          data?.completed_status === 0 &&
                          onTextareaChange(e);
                      }}
                    />
                    <label for="signHereInput" class=" font-enter-color">
                      Sign Here
                    </label>
                  </div>
                </div>

                <div class="col-6">
                  <div class="form-floating minH mb-3">
                    <input
                      class="form-control"
                      name="i9_employee_today_date"
                      value={
                        generatevalue("i9_employee_today_date") === "" ||
                        generatevalue("i9_employee_today_date") === undefined
                          ? moment().format("MMMM DD, YYYY")
                          : generatevalue("i9_employee_today_date")
                      }
                    />
                    <label for="dateInput" class=" font-enter-color">
                      Date
                    </label>
                  </div>
                </div>

                {/* <div class="col-md-6">
        <p className='para-fonts'>Today's Date (mm/dd/yyyy)</p>   
        <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
        </div> */}

                {isReview && (
                  <>
                    <p className="head-l mt-5 mb-4">
                      <span>
                        <strong>Employer Review and Verification I-9</strong>
                      </span>
                    </p>

                    <p className="para-fonts">
                      <strong>
                        Section 2. Employer Review and Verification:
                      </strong>
                      Employers or their authorized representative must complete
                      and sign
                      <strong> Section 2 </strong>within three business days
                      after the employee's first day of employment, and must
                      physically examine, or examine consistent with an
                      alternative procedure authorized by the Secretary of DHS,
                      documentation from List A OR a combination of
                      documentation from List B and List C. Enter any additional
                      documentation in the Additional Information box; see
                      Instructions.
                    </p>

                    <p className="para-fonts">
                      <strong>List A</strong>
                    </p>
                    <div class="col-md-6">
                      <p className="para-fonts">
                        <strong>Document Title 1 </strong>
                      </p>
                      <textarea
                        class="form-control text-class"
                        style={{
                          border:
                            error === true &&
                            generatevalue("listA_document_title1") === "" &&
                            generatevalue("listB_document1") === "" &&
                            generatevalue("listC_document1") === ""
                              ? "1px solid red"
                              : null,
                        }}
                        id="your-message"
                        name="listA_document_title1"
                        rows="5"
                        value={generatevalue("listA_document_title1")}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    <div class="col-md-6">
                      <p className="para-fonts">Issuing Authority </p>
                      <textarea
                        class="form-control text-class"
                        style={{
                          border:
                            error === true &&
                            ((generatevalue("listA_document_title1") === "" &&
                              generatevalue("listB_document1") === "" &&
                              generatevalue("listC_document1") === "") ||
                              (generatevalue("listA_document_title1") !== "" &&
                                generatevalue("listA_issuing_authority1") ===
                                  ""))
                              ? "1px solid red"
                              : null,
                        }}
                        id="your-message"
                        name="listA_issuing_authority1"
                        rows="5"
                        value={generatevalue("listA_issuing_authority1")}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    <div class="col-md-6">
                      <p className="para-fonts">Document Number (if any) </p>
                      <textarea
                        class="form-control text-class"
                        id="your-message"
                        name="listA_document_number1"
                        rows="5"
                        value={generatevalue("listA_document_number1")}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    <div class="col-md-6">
                      <p className="para-fonts">Expiration Date (if any) </p>
                      <textarea
                        class="form-control text-class"
                        id="your-message"
                        name="listA_expiration_date1"
                        rows="5"
                        value={generatevalue("listA_expiration_date1")}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    <div class="col-md-6">
                      <p className="para-fonts">
                        <strong>Document Title 2 (if any) </strong>
                      </p>
                      <textarea
                        class="form-control text-class"
                        id="your-message"
                        name="listA_document_title2"
                        rows="5"
                        value={generatevalue("listA_document_title2")}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    <div class="col-md-6">
                      <p className="para-fonts">Issuing Authority </p>
                      <textarea
                        class="form-control text-class"
                        id="your-message"
                        name="listA_issuing_authority2"
                        rows="5"
                        value={generatevalue("listA_issuing_authority2")}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    <div class="col-md-6">
                      <p className="para-fonts">Document Number (if any) </p>
                      <textarea
                        class="form-control text-class"
                        id="your-message"
                        name="listA_document_number2"
                        rows="5"
                        value={generatevalue("listA_document_number2")}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    <div class="col-md-6">
                      <p className="para-fonts">Expiration Date (if any) </p>
                      <textarea
                        class="form-control text-class"
                        id="your-message"
                        name="listA_expiration_date2"
                        rows="5"
                        value={generatevalue("listA_expiration_date2")}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    <div class="col-md-6">
                      <p className="para-fonts">
                        <strong>Document Title 3 (if any) </strong>
                      </p>
                      <textarea
                        class="form-control text-class"
                        id="your-message"
                        name="listA_document_title3"
                        rows="5"
                        value={generatevalue("listA_document_title3")}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    <div class="col-md-6">
                      <p className="para-fonts">Issuing Authority </p>
                      <textarea
                        class="form-control text-class"
                        id="your-message"
                        name="listA_issuing_authority3"
                        rows="5"
                        value={generatevalue("listA_issuing_authority3")}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    <div class="col-md-6">
                      <p className="para-fonts">Document Number (if any) </p>
                      <textarea
                        class="form-control text-class"
                        id="your-message"
                        name="listA_document_number3"
                        rows="5"
                        value={generatevalue("listA_document_number3")}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    <div class="col-md-6">
                      <p className="para-fonts">Expiration Date (if any) </p>
                      <textarea
                        class="form-control text-class"
                        id="your-message"
                        name="listA_expiration_date3"
                        rows="5"
                        value={generatevalue("listA_expiration_date3")}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    <p className="para-fonts">
                      <strong>List B</strong>
                    </p>

                    <div class="col-md-6">
                      <p className="para-fonts">
                        <strong>Document Title 1 </strong>
                      </p>
                      <textarea
                        class="form-control text-class"
                        style={{
                          border:
                            error === true &&
                            generatevalue("listA_document_title1") === "" &&
                            generatevalue("listB_document1") === "" &&
                            generatevalue("listC_document1") === ""
                              ? "1px solid red"
                              : null,
                        }}
                        id="your-message"
                        name="listB_document1"
                        rows="5"
                        value={generatevalue("listB_document1")}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    <div class="col-md-6">
                      <p className="para-fonts">Issuing Authority </p>
                      <textarea
                        class="form-control text-class"
                        style={{
                          border:
                            error === true &&
                            ((generatevalue("listA_document_title1") === "" &&
                              generatevalue("listB_document1") === "" &&
                              generatevalue("listC_document1") === "") ||
                              (generatevalue("listB_document1") !== "" &&
                                generatevalue("listB_document2") === ""))
                              ? "1px solid red"
                              : null,
                        }}
                        id="your-message"
                        name="listB_document2"
                        rows="5"
                        value={generatevalue("listB_document2")}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    <div class="col-md-6">
                      <p className="para-fonts">Document Number (if any) </p>
                      <textarea
                        class="form-control text-class"
                        id="your-message"
                        name="listB_document3"
                        rows="5"
                        value={generatevalue("listB_document3")}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    {generatevalue("listB_document4") !== undefined && (
                      <div class="col-md-6">
                        <p className="para-fonts">Expiration Date (if any) </p>
                        <textarea
                          class="form-control text-class"
                          id="your-message"
                          name="listB_document4"
                          rows="5"
                          value={generatevalue("listB_document4")}
                          onBlur={(e) => {
                            onTextAreaBlur(e);
                          }}
                          onChange={(e) => {
                            onTextareaChange(e);
                          }}
                        ></textarea>
                      </div>
                    )}

                    {generatevalue("listB_document4\r\n") !== undefined && (
                      <div class="col-md-6">
                        <p className="para-fonts">Expiration Date (if any) </p>
                        <textarea
                          class="form-control text-class"
                          id="your-message"
                          name={formData[45]?.label}
                          rows="5"
                          value={generatevalue(formData[45]?.label)}
                          onBlur={(e) => {
                            onTextAreaBlur(e);
                          }}
                          onChange={(e) => {
                            onTextareaChange(e);
                          }}
                        ></textarea>
                      </div>
                    )}
                    {/* <div class="col-md-6">
        <p className='para-fonts'><strong>Document Title 2 (if any)   </strong></p>   
        <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
        </div>

        <div class="col-md-6">
         <p className='para-fonts'>Issuing Authority    </p>
          <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
        </div>

        <div class="col-md-6">
         <p className='para-fonts'>Document Number (if any)     </p>
          <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
        </div>

        <div class="col-md-6">
         <p className='para-fonts'>Expiration Date (if any)   </p>
          <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
        </div>

        <div class="col-md-6">
        <p className='para-fonts'><strong>Document Title 3 (if any)     </strong></p>   
        <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
        </div>

        <div class="col-md-6">
         <p className='para-fonts'>Issuing Authority     </p>
          <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
        </div>

        <div class="col-md-6">
         <p className='para-fonts'>Document Number (if any)     </p>
          <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
        </div>

        <div class="col-md-6">
         <p className='para-fonts'>Expiration Date (if any)   </p>
          <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
        </div> */}

                    <p className="para-fonts">
                      <strong>List C</strong>
                    </p>

                    <div class="col-md-6">
                      <p className="para-fonts">
                        <strong>Document Title 1 </strong>
                      </p>
                      <textarea
                        class="form-control text-class"
                        style={{
                          border:
                            error === true &&
                            generatevalue("listA_document_title1") === "" &&
                            generatevalue("listB_document1") === "" &&
                            generatevalue("listC_document1") === ""
                              ? "1px solid red"
                              : null,
                        }}
                        id="your-message"
                        name="listC_document1"
                        rows="5"
                        value={generatevalue("listC_document1")}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    <div class="col-md-6">
                      <p className="para-fonts">Issuing Authority </p>
                      <textarea
                        class="form-control text-class"
                        style={{
                          border:
                            error === true &&
                            ((generatevalue("listA_document_title1") === "" &&
                              generatevalue("listB_document1") === "" &&
                              generatevalue("listC_document1") === "") ||
                              (generatevalue("listC_document1") !== "" &&
                                generatevalue("listC_document2") === ""))
                              ? "1px solid red"
                              : null,
                        }}
                        id="your-message"
                        name="listC_document2"
                        rows="5"
                        value={generatevalue("listC_document2")}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    <div class="col-md-6">
                      <p className="para-fonts">Document Number (if any) </p>
                      <textarea
                        class="form-control text-class"
                        id="your-message"
                        name="listC_document3"
                        rows="5"
                        value={generatevalue("listC_document3")}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    <div class="col-md-6">
                      <p className="para-fonts">Expiration Date (if any) </p>
                      <textarea
                        class="form-control text-class"
                        id="your-message"
                        name="listC_document4"
                        rows="5"
                        value={generatevalue("listC_document4")}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    {/* <div class="col-md-6">
        <p className='para-fonts'><strong>Document Title 2 (if any)   </strong></p>   
        <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
        </div>

        <div class="col-md-6">
        <p className='para-fonts'>Issuing Authority    </p>
          <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
        </div>

        <div class="col-md-6">
        <p className='para-fonts'>Document Number (if any)     </p>
          <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
        </div>

        <div class="col-md-6">
        <p className='para-fonts'>Expiration Date (if any)   </p>
          <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
        </div>

        <div class="col-md-6">
        <p className='para-fonts'><strong>Document Title 3 (if any)     </strong></p>   
        <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
        </div>

        <div class="col-md-6">
        <p className='para-fonts'>Issuing Authority     </p>
          <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
        </div>

        <div class="col-md-6">
        <p className='para-fonts'>Document Number (if any)     </p>
          <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
        </div>

        <div class="col-md-6">
        <p className='para-fonts'>Expiration Date (if any)   </p>
          <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
        </div> */}

                    <div class="col-md-12">
                      <p className="para-fonts">Additional Information </p>
                      <textarea
                        class="form-control text-class"
                        id="your-message"
                        name="list_additional_information"
                        rows="5"
                        value={generatevalue("list_additional_information")}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    <div class="col-12">
                      <div class="form-check wraper">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="flexCheckDefault"
                          name="list_checkbox"
                          value={
                            generatevalue("list_checkbox") === ""
                              ? "false"
                              : generatevalue("list_checkbox") === "false"
                              ? "true"
                              : "false"
                          }
                          onChange={(e) => {
                            onTextareaChange(e);
                            onTextAreaBlur(e);
                          }}
                          checked={generatevalue("list_checkbox") === "true"}
                        />
                        <label class="form-check-label" for="flexCheckDefault">
                          Check here if you used an alternative procedure
                          authorized by DHS to examine documents.
                        </label>
                      </div>
                    </div>
                    {/* <div class="col-12">
          <p className='para-fonts'>Check here if you used an alternative procedure authorized by DHS to examine documents</p>
          <input type="radio" class="form-check-input radio-sizee" name="vehicle1" value="Bike"/>
          <label for="vehicle1" className=' w4form-l'> Yes</label>

        </div>

        <div class="col-12">
          <input type="radio" class="form-check-input radio-sizee" name="vehicle1" value="Bike"/>
          <label for="vehicle1" className=' w4form-l'> No</label>
        </div> */}
                    {/* 
        <p className='para-fonts'><strong>Certification: I attest, under penalty of perjury, that (1) I
           have examined the documentation presented by the above-named employee, (2) the above-listed 
           documentation appears to be genuine and to relate to the employee named, and (3) to the best
            of my knowledge, the employee is authorized to work in the United States.</strong></p> */}

                    <div class="col-md-6">
                      <p className="para-fonts">
                        First Day of Employment (mm/dd/yyyy):{" "}
                      </p>
                      <textarea
                        class="form-control text-class"
                        style={{
                          border:
                            error === true &&
                            (generatevalue("i9_employer_firstday") === "" ||
                              generatevalue("i9_employer_firstday") === null)
                              ? "1px solid red"
                              : null,
                        }}
                        id="your-message"
                        name="i9_employer_firstday"
                        rows="5"
                        value={generatevalue("i9_employer_firstday")}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    <div class="col-md-6">
                      <p className="para-fonts">
                        Last Name, First Name and Title of Employer or
                        Authorized Representative{" "}
                      </p>
                      <textarea
                        class="form-control text-class"
                        style={{
                          border:
                            error === true &&
                            (generatevalue("i9_last_name_title_employer") ===
                              "" ||
                              generatevalue("i9_last_name_title_employer") ===
                                null)
                              ? "1px solid red"
                              : null,
                        }}
                        id="your-message"
                        name="i9_last_name_title_employer"
                        rows="5"
                        value={generatevalue("i9_last_name_title_employer")}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    <div class="col-12">
                      <div class="form-check wraper">
                        {/* <input class="form-check-input" type="checkbox" id="flexCheckDefault" value=""/> */}
                        <label class="form-check-label" for="flexCheckDefault">
                          I attest, under penalty of perjury, that (1) I have
                          examined the documentation presented by the
                          above-named employee, (2) the above-listed
                          documentation appears to be genuine and to relate to
                          the employee named, and (3) to the best of my
                          knowledge, the employee is authorized to work in the
                          United States.
                        </label>
                      </div>
                    </div>

                    <div class="col-6">
                      <div class="form-floating wraper minH mb-3">
                        <input
                          type="text"
                          class="form-control signs"
                          style={{
                            border:
                              error === true &&
                              (generatevalue("i9_employer_sign") === "" ||
                                generatevalue("i9_employer_sign") === null)
                                ? "1px solid red"
                                : null,
                          }}
                          id="your-message"
                          name="i9_employer_sign"
                          rows="5"
                          value={generatevalue("i9_employer_sign")}
                          onBlur={(e) => {
                            onTextAreaBlur(e);
                          }}
                          onChange={(e) => {
                            onTextareaChange(e);
                          }}
                        />
                        <label for="signHereInput" class=" font-enter-color">
                          Sign Here
                        </label>
                      </div>
                    </div>

                    <div class="col-6">
                      <div class="form-floating minH mb-3">
                        <input
                          class="form-control"
                          name="i9_employer_todays_date"
                          value={
                            generatevalue("i9_employer_todays_date") === "" ||
                            generatevalue("i9_employer_todays_date") ===
                              undefined
                              ? moment().format("MMMM DD, YYYY")
                              : generatevalue("i9_employer_todays_date")
                          }
                        />
                        <label for="dateInput" class=" font-enter-color">
                          Date
                        </label>
                      </div>
                    </div>

                    {/* <div class="col-md-6">
        <p className='para-fonts'>Today's Date (mm/dd/yyyy)</p>   
        <textarea class="form-control text-class" id="your-message" name="your-message" rows="5" required></textarea>
        </div> */}

                    <div class="col-md-6">
                      <p className="para-fonts">
                        Employer's Business or Organization Name
                      </p>
                      <textarea
                        class="form-control text-class"
                        style={{
                          border:
                            error === true &&
                            (generatevalue("i9_employer_organization_name") ===
                              "" ||
                              generatevalue("i9_employer_organization_name") ===
                                null)
                              ? "1px solid red"
                              : null,
                        }}
                        id="your-message"
                        name="i9_employer_organization_name"
                        rows="5"
                        value={generatevalue("i9_employer_organization_name")}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>

                    <div class="col-md-6 mb-4">
                      <p className="para-fonts">
                        Employer's Business or Organization Address, City or
                        Town, State, ZIP Code
                      </p>
                      <textarea
                        class="form-control text-class"
                        style={{
                          border:
                            error === true &&
                            (generatevalue(
                              "i9_employer_organization_address"
                            ) === "" ||
                              generatevalue(
                                "i9_employer_organization_address"
                              ) === null)
                              ? "1px solid red"
                              : null,
                        }}
                        id="your-message"
                        name="i9_employer_organization_address"
                        rows="5"
                        value={generatevalue(
                          "i9_employer_organization_address"
                        )}
                        onBlur={(e) => {
                          onTextAreaBlur(e);
                        }}
                        onChange={(e) => {
                          onTextareaChange(e);
                        }}
                      ></textarea>
                    </div>
                  </>
                )}
                {data.completed_status === 0 && !isReview && (
                  <div className="col-lg-12  align-items-center justify-content-end">
                    <div className="form-floating mb-3 justify-content-end wraper">
                      <button
                        className="submits-btn rounded p-2"
                        onClick={(e) => {
                          submitForm(e);
                        }}
                      >
                        {/* {item.section_forms?.length === i + 1 ? 'Submit Form' : 'Next Form'}  */}
                        Submit Form
                      </button>
                    </div>
                  </div>
                )}

                {data?.completed_status === 1 &&
                  data.employer_status === 0 &&
                  isReview && (
                    <div className="col-lg-12  align-items-center justify-content-end">
                      <div className="form-floating mb-3 justify-content-end wraper">
                        <button
                          className="submits-btn rounded p-2"
                          onClick={(e) => {
                            e.preventDefault();
                            submitForm(e);
                          }}
                        >
                          {" "}
                          Confirm Form{" "}
                        </button>
                      </div>
                    </div>
                  )}
                {data.employer_status === 1 && isReview && (
                  <div className="col-lg-12  align-items-center justify-content-end">
                    <div className="form-floating mb-3 justify-content-end wraper">
                      <button
                        className="submits-btn rounded p-2"
                        onClick={(e) => {
                          e.preventDefault();
                          submitForm(e);
                        }}
                      >
                        {" "}
                        Update Form{" "}
                      </button>
                    </div>
                  </div>
                )}
                {data?.employer_status === 1 && isReview && fileName !== "" && (
                  <div className="col-lg-12  align-items-center justify-content-end">
                    <div className="form-floating mb-3 justify-content-end wraper">
                      <button
                        className="submits-btn rounded p-2 sub-bttn-right-sides"
                        onClick={(e) => {
                          e.preventDefault();
                          let filepath = API.legalFormsView + fileName;
                          if (fileName !== "") {
                            const link = document.createElement("a");
                            link.href = filepath;
                            link.download = "avenu";
                            link.target = "_blank";
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                          }
                        }}
                      >
                        Download{" "}
                      </button>

                      {/* <button className='submits-btn rounded p-2 sub-bttn-right-sides' 
                                                                    onClick={(e) => { submitForm(e, 'Updated') }}> Update Form </button> */}
                    </div>
                  </div>
                )}
              </div>
            </form>
          </div>
          <div
            className={
              location?.pathname ===
              "/dashboard/review/" + params.id + "/" + params.caseId
                ? "box-two active-boxs mt-2"
                : "box-two mt-2"
            }
          >
            {isReview && unconfirmedData.length !== 0 ? (
              <>
                {/* <hr></hr> */}
                <div className="">
                  <img
                    src={caselogo}
                    alt="test"
                    className="caselogoi9-are-top  "
                  />
                </div>
                {/* <div className="">
                  <img src={Alertsi9} alt="test" className="alert9" />
                  <span>
                    <strong>Are you sure ?</strong>{" "}
                  </span>
                </div>

                <div className="alert9-div  mb-2">
                  {unconfirmedData?.map((item, index) => {
                    return (
                      <div className="mb-2">
                        <p className="para-fonts-new">
                          {item?.everify_label === "ssn"
                            ? "SSN"
                            : item?.everify_label
                                .split("_")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() + word.slice(1)
                                )
                                .join(" ")}{" "}
                          Entered
                        </p>
                        <p className="para-fonts-new">
                          {item?.field_label === "listB_document3"
                            ? unconfirmedFields[index]?.defaultValue
                            : isValidDateString(
                                unconfirmedFields[index]?.defaultValue
                              )
                            ? formatDateToYYYYMMDD(
                                unconfirmedFields[index]?.defaultValue
                              )
                            : (console.log(
                                unconfirmedFields[index]?.defaultValue
                              ),
                              unconfirmedFields[index]?.defaultValue)}
                        </p>

                        <div class="col-12">
                          <input
                            type="radio"
                            checked={unconfirmedFields[index]?.toggle === false}
                            class="form-check-input radio-sizee"
                            style={{
                              border:
                                error === true &&
                                (generatevalue("checkbox") === "" ||
                                  generatevalue("checkbox") === null)
                                  ? "1px solid red"
                                  : null,
                            }}
                            name={item?.everify_label}
                            onChange={(e) => {
                              let arr = [...unconfirmedFields];
                              arr[index].toggle = false;
                              setUnconfirmedFields(arr);
                              console.log(arr);
                            }}
                          />
                          <label for="vehicle1" className=" w4form-l">
                            Information entered matches Form I-9
                          </label>
                        </div>

                        <div class="col-12">
                          <input
                            type="radio"
                            checked={unconfirmedFields[index]?.toggle === true}
                            class="form-check-input radio-sizee"
                            name={item?.everify_label}
                            onChange={(e) => {
                              let arr = [...unconfirmedFields];
                              arr[index].toggle = true;
                              setUnconfirmedFields(arr);
                              console.log(arr);
                            }}
                          />
                          <label for="vehicle1" className=" w4form-l">
                            Information entered does not match Form I-9 (field
                            for update will be provided below)
                          </label>
                        </div>

                        {unconfirmedFields[index]?.toggle === true && (
                          <div class="col-md-6">
                            <p className="para-fonts-new">
                              Update{" "}
                              {item?.everify_label === "ssn"
                                ? "SSN"
                                : item?.everify_label
                                    .split("_")
                                    .map(
                                      (word) =>
                                        word.charAt(0).toUpperCase() +
                                        word.slice(1)
                                    )
                                    .join(" ")}{" "}
                              Entry{" "}
                            </p>
                            {item?.everify_label === "us_state_code" ? (
                              <select
                                class="form-select select-height"
                                aria-label="Default select example"
                                id="your-message"
                                name={item?.field_label}
                                rows="5"
                                value={unconfirmedFields[index]?.updatedValue}
                                onChange={(e) => {
                                  let arr = [...unconfirmedFields];
                                  arr[index].updatedValue = e.target.value;
                                  setUnconfirmedFields(arr);
                                  console.log(arr);
                                }}
                              >
                                {/* <option selected value=''>select</option> *
                                {states.map((item) => {
                                  return <option value={item}>{item}</option>;
                                })}
                              </select>
                            ) : item?.everify_label ===
                              "foreign_passport_number" ? (
                              <div className="d-flex">
                                <textarea
                                  class="form-control text-class"
                                  id="your-message"
                                  name="i9_employee_foreign_passport_number"
                                  rows="5"
                                  value={
                                    unconfirmedFields[index]?.updatedFirstValue
                                  }
                                  onChange={(e) => {
                                    let arr = [...unconfirmedFields];
                                    arr[index].updatedFirstValue =
                                      e.target.value;
                                    arr[index].updatedValue =
                                      arr[index].updatedFirstValue +
                                      " " +
                                      arr[index].updatedSecondValue;
                                    setUnconfirmedFields(arr);
                                    console.log(arr);
                                  }}
                                ></textarea>
                                <select
                                  class="form-select select-height mx-2"
                                  aria-label="Default select example"
                                  id="your-message"
                                  name="i9_employee_foreign_passport_number"
                                  rows="5"
                                  value={
                                    unconfirmedFields[index]?.updatedSecondValue
                                  }
                                  onChange={(e) => {
                                    let arr = [...unconfirmedFields];
                                    arr[index].updatedSecondValue =
                                      e.target.value;
                                    arr[index].updatedValue =
                                      arr[index].updatedFirstValue +
                                      " " +
                                      arr[index].updatedSecondValue;
                                    setUnconfirmedFields(arr);
                                    console.log(arr);
                                  }}
                                >
                                  <option selected value="">
                                    select
                                  </option>
                                  {countries?.map((item) => {
                                    return (
                                      <option value={item?.code}>
                                        {item?.name}
                                      </option>
                                    );
                                  })}
                                </select>
                              </div>
                            ) : item?.everify_label === "ssn" ? (
                              <textarea
                                class="form-control text-class"
                                style={{
                                  border:
                                    /^\d{3}-\d{2}-\d{4}$/.test(
                                      unconfirmedFields[index]?.updatedValue
                                    ) === false
                                      ? "1px solid red"
                                      : null,
                                }}
                                id="your-message"
                                name={item?.field_label}
                                rows="5"
                                maxLength={11}
                                value={unconfirmedFields[index]?.updatedValue}
                                onChange={(e) => {
                                  let arr = [...unconfirmedFields];
                                  arr[index].updatedValue = e.target.value;
                                  setUnconfirmedFields(arr);
                                  console.log(arr);
                                }}
                              ></textarea>
                            ) : (
                              <textarea
                                class="form-control text-class"
                                id="your-message"
                                name={item?.field_label}
                                rows="5"
                                value={
                                  isValidDateString(
                                    unconfirmedFields[index]?.updatedValue
                                  )
                                    ? formatDateToYYYYMMDD(
                                        unconfirmedFields[index]?.updatedValue
                                      )
                                    : unconfirmedFields[index]?.updatedValue
                                }
                                onChange={(e) => {
                                  let arr = [...unconfirmedFields];
                                  arr[index].updatedValue = e.target.value;
                                  setUnconfirmedFields(arr);
                                  // console.log(arr);
                                }}
                              ></textarea>
                            )}
                          </div>
                        )}
                      </div>
                    );
                  })}
                   <div className='col-lg-12  align-items-center justify-content-end'>
                                                                          <div className="form-floating mb-3 justify-content-end wraper">
                                                                          <button className='submits-btn rounded p-2 case-bttn' onClick={(e) => {e.preventDefault(); console.log('test'); reverify() }}> 
                                                                            <img src={caselogo} alt="test" className="caselogoi9  "/>
                                                                            </button>
                                                                              
                                                              
                                                                          </div>
            
                                                                      </div> 
                  <div className="col-lg-12  align-items-center justify-content-end">
                    <div className="form-floating mb-3 justify-content-end wraper">
                      {/* <button className='submits-btn rounded p-2' onClick={everify}>Verify</button> */}
                {/* <button className='submits-btn rounded p-2 sub-bttn-right-sides-download'>
                                                                                Download </button> 

                      <button
                        className="submits-btn rounded p-2 sub-bttn-right-sides e-vef-bttn-sub"
                        onClick={(e) => {
                          e.preventDefault();
                          reverify();
                        }}
                      >
                        {" "}
                        Submit to E-verify{" "}
                      </button>
                    </div>
                  </div>
                </div> */}
              </>
            ) : (
              <div>
                {isReview && data?.case_status !== null && (
                  <div className="display-gds">
                    {location?.pathname ===
                      "/review/" + params?.id + "/" + params?.index && <hr />}

                    <div className="mb-2">
                      <img
                        src={caselogo}
                        alt="test"
                        className="caselogoi9-are-top  "
                      />
                    </div>

                    <div className="top-match-align">
                      {data?.case_status === "CLOSED" &&
                        data?.case_eligibility_statement ===
                          "EMPLOYMENT_AUTHORIZED" && (
                          <span className="right-side-lable-match mt-2 mb-4">
                            <span className="employment-text-bg ">
                              EMPLOYMENT AUTHORIZED
                            </span>
                            <span className="close-final-bg">CLOSED</span>
                          </span>
                        )}

                      {data?.case_status === "CLOSED" &&
                        data?.case_eligibility_statement ===
                          "NO_ACTION_FNC" && (
                          <span className="right-side-lable-match mt-2 mb-4">
                            <span className="Final-text-bg ">
                              FINAL NONCONFIRMATION
                            </span>
                            <span className="close-final-bg">CLOSED</span>
                          </span>
                        )}
                      {data?.case_status === "CLOSED" &&
                        data?.case_eligibility_statement ===
                          "NOT_AUTHORIZED_EMPLOYMENT" && (
                          <span className="right-side-lable-match mt-2 mb-4">
                            <span className="Final-text-bg ">
                              FINAL NONCONFIRMATION
                            </span>
                            <span className="close-final-bg">CLOSED</span>
                          </span>
                        )}

                      {data?.case_status === "CLOSED" &&
                        data?.case_eligibility_statement ===
                          "RESUBMIT_CASE" && (
                          <span className="right-side-lable-match mt-2 mb-4">
                            <span className="Resubmit-text-bg ">
                              CLOSED CASE AND RESUBMIT
                            </span>
                            <span className="open-final-bg">CLOSED</span>{" "}
                          </span>
                        )}

                      {data?.case_status === "CLOSE_CASE_AND_RESUBMIT" &&
                        data?.case_eligibility_statement ===
                          "RESUBMIT_CASE" && (
                          <span className="right-side-lable-match mt-2x mb-4">
                            <span className="Resubmit-text-bg ">
                              CLOSED CASE AND RESUBMIT
                            </span>
                            <span className="open-final-bg">OPEN</span>{" "}
                          </span>
                        )}

                      {data?.case_status === "CLOSED" &&
                        data?.case_eligibility_statement === null && (
                          <span className="right-side-lable-match mt-2 mb-4">
                            <span className="Final-text-bg ">
                              {data?.case_status_display.toUpperCase()}
                            </span>
                            <span className="close-final-bg">CLOSED</span>
                          </span>
                        )}
                      {data?.case_status === "MANUAL_REVIEW" && (
                        <span className=" right-side-lable-match mt-2 mb-4">
                          <span className="emp-dhs-bg">
                            {data?.case_status_display.toUpperCase()}
                          </span>
                          <span className="open-final-bg">OPEN</span>{" "}
                        </span>
                      )}

                      {data?.case_status === "PHOTO_MATCH" && (
                        <span className="right-side-lable-match mt-2 mb-4">
                          <span className="emp-dhs-bg">
                            {data?.case_status_display.toUpperCase()}
                          </span>
                          <span className="open-final-bg">OPEN</span>{" "}
                        </span>
                      )}

                      {data?.case_status === "PENDING_REFERRAL" && (
                        <span className=" right-side-lable-match mt-2 mb-4">
                          <span className="tent-non-bg">
                            {data?.case_status_display.toUpperCase()}
                          </span>
                          <span className="open-final-bg">OPEN</span>{" "}
                        </span>
                      )}

                      {data?.case_status === "REFERRED" && (
                        <span className="right-side-lable-match mt-2 mb-4">
                          <span className="emp-dhs-bg">
                            {data?.case_status_display.toUpperCase()}
                          </span>
                          <span className="open-final-bg">OPEN</span>{" "}
                        </span>
                      )}

                      {data?.case_status === "QUEUED" && (
                        <span className="right-side-lable-match mt-2 mb-4">
                          <span className="emp-dhs-bg">
                            {data?.case_status_display.toUpperCase()}
                          </span>
                          <span className="open-final-bg">OPEN</span>{" "}
                        </span>
                      )}

                      {data?.case_status === "DRAFT" && (
                        <span className="right-side-lable-match mb-4">
                          <span className="case-incom">
                            {data?.case_status_display.toUpperCase()}
                          </span>
                          <span className="open-final-bg">OPEN</span>{" "}
                        </span>
                      )}

                      {data?.case_status === "FINAL_NONCONFIRMATION" && (
                        <span className="right-side-lable-match mb-4">
                          <span className="Final-text-bg ">
                            {data?.case_status_display.toUpperCase()}
                          </span>
                          <span className="open-final-bg">OPEN</span>{" "}
                        </span>
                      )}
                      <hr></hr>

                      {data?.case_status === "CLOSED" &&
                        data?.case_eligibility_statement ===
                          "EMPLOYMENT_AUTHORIZED" && (
                          <p className="mt-3">
                            The employee’s information matched records available
                            to DHS and/or SSA.
                          </p>
                        )}
                      {data?.case_status === "CLOSED" &&
                        data?.case_eligibility_statement ===
                          "NO_ACTION_FNC" && (
                          <p className="mt-3">
                            E-Verify cannot confirm an employee’s employment
                            eligibility after the employee contacted DHS or
                            visited SSA.
                          </p>
                        )}
                      {data?.case_status === "FINAL_NONCONFIRMATION" && (
                        <>
                          {" "}
                          <p className="mt-2">
                            Unfortunately, we were unable to confirm
                            {generatevalue("i9_employee_firstname") +
                              " " +
                              generatevalue("i9_employee_lastname")}
                            ’s authorization for employment. Please close{" "}
                            {generatevalue("i9_employee_firstname")}'s case
                            below to indicate whether or not you intend to
                            continue {generatevalue("i9_employee_firstname")}'s
                            employment.
                          </p>
                          <button
                            className="submits-btn rounded p-2"
                            onClick={(e) => {
                              e.preventDefault();
                              setCloseCaseModal(true);
                            }}
                          >
                            {" "}
                            Close Case{" "}
                          </button>
                        </>
                      )}

                      {data?.case_status === "CLOSE_CASE_AND_RESUBMIT" && (
                        <>
                          {" "}
                          <p className="mt-2">
                            Something is incorrect in the data submitted.
                            E-Verify needs you to close this case and re-enter
                            {generatevalue("i9_employee_firstname") +
                              " " +
                              generatevalue("i9_employee_lastname")}
                            ’s information in a new case.
                          </p>
                          <button
                            className="submits-btn rounded p-2"
                            onClick={(e) => {
                              closeCase(
                                e,
                                "EMPLOYER_INSTRUCTED_TO_CREATE_NEW_CASE"
                              );
                            }}
                          >
                            {" "}
                            Close Case{" "}
                          </button>
                        </>
                      )}

                      {data?.case_status === "MANUAL_REVIEW" && (
                        <p className=" mt-3 common-padding">
                          E-Verify needs more time to confirm that{" "}
                          {generatevalue("i9_employee_firstname") +
                            " " +
                            generatevalue("i9_employee_lastname")}{" "}
                          is authorized to work in the United States. You should
                          not take any action against{" "}
                          {generatevalue("i9_employee_firstname")} while
                          E-Verify is reviewing this case.
                        </p>
                      )}
                      {data?.case_status === "QUEUED" && (
                        <p className=" mt-3 common-padding">
                          E-Verify needs more time to confirm that{" "}
                          {generatevalue("i9_employee_firstname") +
                            " " +
                            generatevalue("i9_employee_lastname")}{" "}
                          is authorized to work in the United States. You should
                          not take any action against{" "}
                          {generatevalue("i9_employee_firstname")} while
                          E-Verify is reviewing this case.
                        </p>
                      )}
                    </div>

                    {/* {data?.case_status === "PHOTO_MATCH" && (
                      <div class="row mt-3">
                        <div class="col-12">
                          <p className="para-fonts-match">
                            <strong>Photo Match</strong>
                          </p>
                          {photMatchImage !== "" ? (
                            <img
                              src={`data:image/jpeg;base64,${photMatchImage}`}
                              style={{ height: "45%", width: "20%" }}
                            />
                          ) : (
                            <p className="">Not Found</p>
                          )}
                          <p className="">
                            Does the photo displayed match the photo displayed
                            on{" "}
                            {generatevalue("i9_employee_firstname") +
                              " " +
                              generatevalue("i9_employee_lastname")}
                            's Permanent Resident or Card Alien Registration
                            Receipt Card(Form i-559)
                          </p>
                          <div class="col-9">
                            <input
                              id="photMatch"
                              type="radio"
                              class="form-check-input radio-sizee"
                              style={{
                                border:
                                  photoMatchErr === true
                                    ? "1px solid red"
                                    : null,
                              }}
                              onChange={() => {
                                setPhotoMatchStatus("matching");
                              }}
                              checked={photoMatchStatus === "matching"}
                            />
                            <label for="vehicle2" className=" w4form-l">
                              Yes , this photo matches
                            </label>
                          </div>
                          <div class="col-9">
                            <input
                              id="photMatch"
                              type="radio"
                              class="form-check-input radio-sizee"
                              style={{
                                border:
                                  photoMatchErr === true
                                    ? "1px solid red"
                                    : null,
                              }}
                              onChange={() => {
                                setPhotoMatchStatus("not-matching");
                              }}
                              checked={photoMatchStatus === "not-matching"}
                            />
                            <label for="vehicle2" className=" w4form-l">
                              No , this photo does not matches
                            </label>
                          </div>
                          <div class="col-9">
                            <input
                              id="photMatch"
                              type="radio"
                              class="form-check-input radio-sizee"
                              style={{
                                border:
                                  photoMatchErr === true
                                    ? "1px solid red"
                                    : null,
                              }}
                              onChange={() => {
                                setPhotoMatchStatus("no-image");
                              }}
                              checked={photoMatchStatus === "no-image"}
                            />
                            <label for="vehicle2" className=" w4form-l">
                              No , photo displayed
                            </label>
                          </div>
                          <div className="butts-div-photo-match">
                            <button
                              type="button"
                              class="primary-bttn"
                              onClick={(e) => {
                                photoMatch(e);
                              }}
                            >
                              Continue to Case Result
                            </button>
                            {/* <button
                                          type="button"
                                          class="btn btn-outline-primary primay-linr-bttn"
                                        >
                                          Save & Edit
                                        </button> 
                          </div>
                        </div>
                      </div>
                    )}

                    {data?.case_status === "SCAN_AND_UPLOAD" && (
                      <div class="row">
                        <div class="col-12">
                          <p className="para-fonts">
                            <strong>
                              Upload Sam's Permanent Resident Card or alien
                              Registration Receipt Card (Form i-551){" "}
                            </strong>
                          </p>
                          <div class="col-9">
                            <p className="">
                              Because there was no photo found sam adam submit a
                              vaild photo of{" "}
                              {generatevalue("i9_employee_firstname") +
                                " " +
                                generatevalue("i9_employee_lastname")}
                              's form i-551 by uploading images from your
                              computer. The file can be a <strong>.jpg</strong>{" "}
                              ,<strong>.pdf</strong> or <strong>png </strong>{" "}
                              file no greater than 5MB.
                            </p>
                          </div>

                          <div class="col-12">
                            <p>
                              {" "}
                              1. Please uploadthe{" "}
                              <strong>Front of Document</strong> page
                            </p>
                            <div className="">
                              <button
                                type="button"
                                class="primary-bttn bros-bttn"
                                style={{
                                  border:
                                    scanandUploadErr === true &&
                                    frontImage === ""
                                      ? "1px solid red"
                                      : null,
                                }}
                              >
                                Browse
                              </button>
                              <input
                                type="file"
                                className="bros-input"
                                accept=".pdf, .jpg, .png"
                                onChange={(e) => {
                                  console.log(e);
                                  setFrontImage(e?.target?.files[0]);
                                }}
                              />

                              <p className="file-chose-img">
                                {frontImage?.name}
                              </p>
                            </div>
                          </div>

                          <div class="col-12 mt-2 ">
                            <p>
                              {" "}
                              2. Please uploadthe{" "}
                              <strong>Back of Document </strong>page
                            </p>
                            <div className="">
                              <button
                                type="button"
                                class="primary-bttn bros-bttn"
                                style={{
                                  border:
                                    scanandUploadErr === true &&
                                    backImage === ""
                                      ? "1px solid red"
                                      : null,
                                }}
                              >
                                Browse
                              </button>
                              <input
                                type="file"
                                className="bros-input  "
                                accept=".pdf, .jpg, .png"
                                onChange={(e) => {
                                  console.log(e);
                                  setBackImage(e?.target?.files[0]);
                                }}
                              />

                              <p className="file-chose-img">
                                {backImage?.name}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="butts-div mt-5">
                          <button
                            type="button"
                            class="primary-bttn bros-bttn"
                            onClick={(e) => {
                              scanandUpload(e);
                            }}
                          >
                            Continue{" "}
                          </button>
                          <button
                                          type="button"
                                          class="btn btn-outline-primary primay-linr-bttn"
                                        >
                                          Save & Edit
                                        </button>
                                        <button
                                          type="button"
                                          class="btn btn-link case-bttnss"
                                        >
                                          <img
                                            src={archive}
                                            alt="test"
                                            className="archive-icon"
                                          />
                                          Close case
                                        </button> 
                        </div>
                      </div>
                    )} */}

                    {data?.case_status === "PENDING_REFERRAL" && (
                      <div className="coutinue-main-divs">
                        <div className="mt-2">
                          <img src={Alertsi9} alt="test" className="alert9" />
                          <span>
                            <strong>
                              Tentative Nonconfirmation (mismatch)
                            </strong>{" "}
                          </span>
                          <p>
                            It’s okay! E-Verify just needs some more information
                            from you and 
                            {generatevalue("i9_employee_firstname") +
                              " " +
                              generatevalue("i9_employee_lastname")}
                             before confirming employment authorization. Here
                            are the next steps you both will need to take.
                          </p>
                          {/* <p>Next steps:</p>
                          <p>
                            <strong>STEP 1</strong>
                          </p>
                          <p>
                            You must download, print, and review the Further
                            Action Notice with 
                            {generatevalue("i9_employee_firstname")}
                             privately. Make sure that 
                            {generatevalue("i9_employee_firstname")} fully
                            understands the Further Action Notice. This document
                            will explain why 
                            {generatevalue("i9_employee_firstname")}
                             received this result, and what to do next.
                          </p>
                          <button
                            className="dfan-btn rounded Download-Notice p-2"
                            onClick={(e) => {
                              downloadfurtherAction(e);
                            }}
                          >
                            Download Further Action Notice
                          </button>
                          <p className="mt-4">
                            <strong>STEP 2</strong>
                          </p>
                          <p>
                            Ask if {generatevalue("i9_employee_firstname")}
                             will choose to take action to resolve this error
                            and correct the data mismatch that led to this
                            result.
                          </p>
                          <ul className="if-{generatevalue('i9_employee_firstname')}">
                            <li>
                              If {generatevalue("i9_employee_firstname")}
                               chooses to take action to resolve this case,
                              indicate that in the option below. Make sure 
                              {generatevalue("i9_employee_firstname")}
                               understands that after you select this option,
                              there will be a deadline of eight federal
                              government working days starting today to take
                              action. If an email was provided, 
                              {generatevalue("i9_employee_firstname")} will
                              receive a confirmation email that indicates when
                              this countdown begins.
                            </li>
                            <li className="mt-3">
                              If {generatevalue("i9_employee_firstname")}
                               chooses not to take action to resolve this case,
                              indicate that in the option below. You will
                              receive a final result that indicates that we were
                              unable to confirm employment eligibility. 
                              {generatevalue("i9_employee_firstname")} needs to
                              understand that refusing to take action could
                              result in losing this job.
                            </li>
                          </ul>

                          <div className="after-mathw-divs">
                            <p>
                              <strong>
                                After 
                                {generatevalue("i9_employee_firstname")} has
                                reviewed the Further Action Notice, indicate the
                                decision below:
                              </strong>
                            </p>

                            <div class="col-12">
                              <input
                                type="radio"
                                class="form-check-input radio-sizee mis"
                                id="action"
                                style={{
                                  border:
                                    furtherActionErr === true
                                      ? "1px solid red"
                                      : null,
                                }}
                                onChange={() => {
                                  setFurtherAction("Step1");
                                  setCloseReason("");
                                }}
                                checked={furtherAction === "Step1"}
                              />
                              <label
                                for="vehicle1"
                                className=" w4form-l micmatch"
                              >
                                <strong>
                                  {generatevalue("i9_employee_firstname")} will
                                  take action to resolve this E-Verify case.
                                </strong>
                                 {generatevalue("i9_employee_firstname")}
                                 understands that action must be taken
                                by October 01, 2024.
                              </label>
                            </div>

                            <div class="col-12">
                              <input
                                type="radio"
                                class="form-check-input radio-sizee mis"
                                style={{
                                  border:
                                    furtherActionErr === true
                                      ? "1px solid red"
                                      : null,
                                }}
                                id="action"
                                onChange={() => {
                                  setFurtherAction("Step2");
                                  setCloseReason("");
                                }}
                                checked={furtherAction === "Step2"}
                              />
                              <label
                                for="vehicle1"
                                className=" w4form-l micmatch"
                              >
                                <strong>
                                  {generatevalue("i9_employee_firstname")}
                                   will not take action to resolve this case.
                                </strong>
                                 {generatevalue("i9_employee_firstname")}
                                 understands that this cannot be undone and
                                choosing not to take action could result in
                                termination of employment.
                              </label>
                            </div>

                            <div class="col-12">
                              <input
                                type="radio"
                                class="form-check-input radio-sizee mis"
                                style={{
                                  border:
                                    furtherActionErr === true
                                      ? "1px solid red"
                                      : null,
                                }}
                                id="action"
                                onChange={() => {
                                  setFurtherAction("Step3");
                                  setCloseReason("INCORRECT_DATA");
                                }}
                                checked={furtherAction === "Step3"}
                              />
                              <label
                                for="vehicle1"
                                className=" w4form-l micmatch"
                              >
                                <strong>
                                  The information entered was not correct.
                                </strong>
                                I am choosing to close this case.
                              </label>
                            </div>
                          </div>

                          {furtherAction === "Step3" ? (
                            <button
                              className="dfan-btn rounded p-2 mt-4"
                              onClick={(e) => {
                                closeCase(e, "");
                              }}
                            >
                              Continue
                            </button>
                          ) : (
                            <button
                              className="dfan-btn rounded p-2 mt-4"
                              onClick={saveFurtherAction}
                            >
                              Continue
                            </button>
                          )}*/}
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {data?.case_status === "CLOSED" &&
                  data?.case_eligibility_statement === "RESUBMIT_CASE" && (
                    <button
                      className="dfan-btn rounded p-2 mt-4"
                      onClick={(e) => {
                        e.preventDefault();
                        resetForm(data);
                      }}
                    >
                      Restart Form
                    </button>
                  )}

                {data?.case_status === "REFERRED" && (
                  <div className="coutinue-main-divs mt-3">
                    <p>
                      <strong>
                        Confirmation: 
                        {generatevalue("i9_employee_firstname")} intends to take
                        action to resolve this case.
                      </strong>
                    </p>
                    {/* <p>
                      You have referred 
                      {generatevalue("i9_employee_firstname") +
                        " " +
                        generatevalue("i9_employee_lastname")}
                       to DHS and SSA on September 19, 2024. To proceed, select
                      a language and download the Referral Date Confirmation
                      below. Provide this to 
                      {generatevalue("i9_employee_firstname")}, who chose to
                      take action this dual DHS/SSA mismatch. 
                      {generatevalue("i9_employee_firstname")} has until 
                      <span className="red-color-text">October 01, 2024</span>
                       to contact DHS and SSA to resolve this issue.
                    </p>
                    <p>
                      If you encounter any issues downloading your document,
                      please ensure that you are using the latest version of
                      your browser and that your pop-up blocker is disabled.
                    </p>
                    <button
                      className="dfan-btn rounded p-2"
                      onClick={(e) => {
                        downloadReferalDateConfirmation(e);
                      }}
                    >
                      Download Referral Date Confirmation
                    </button>
                    <p className="mt-4">
                      E-Verify will update 
                      {generatevalue("i9_employee_firstname")}'s case status
                      through the case status alert feature on your E-Verify
                      homepage. Be sure to log in to E-Verify periodically —
                      you'll need to close the case once it's updated with the
                      final status.
                    </p>
                    {/* <div>
                        <button className='dfan-btn rounded p-2 mt-2'  >Continue</button>
                        <button className='dfan-btn close rounded p-2 mt-2' >Close</button>
                      </div> 
                  </div>
                )} */}
                  </div>
                )}
              </div>
            )}
            {data?.employer_status === 1 &&
              isReview &&
              everifyStatus == true && (
                <div className="col-lg-12  align-items-center justify-content-end">
                  <div className="form-floating mb-3 justify-content-end wraper">
                    <button
                      className="submits-btn rounded p-2 sub-bttn-right-sides"
                      onClick={(e) => {
                        if (data?.e_verify_casId === null) {
                          e.preventDefault();
                          setI9Form();
                          redirectToEverify(data?.id);
                        } else {
                          navigate(
                            "/dashboard/review/" +
                              params?.id +
                              "/" +
                              data?.e_verify_casId
                          );
                        }
                      }}
                    >
                      {data?.e_verify_casId === null
                        ? "Submit to E-verify"
                        : "Go to E-verify"}
                    </button>
                  </div>
                </div>
              )}

            {location.pathname ===
              "/dashboard/review/" + params?.id + "/" + params?.caseId && (
              <hr />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OldI9form;
